import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => ({
	fixedBoard: {
		display: "flex",
		flexDirection: "column",
		gap: 4,
	},
	fixedBoardLabel: {
		fontSize: 14,
		color: theme.palette.custom.textSecondary,
	},
} satisfies Record<string, CSSObject>);
